export var HdsIconlibraryPoi_24px;
(function (HdsIconlibraryPoi_24px) {
    HdsIconlibraryPoi_24px["AccommodationOutline_24px"] = "accommodation_outline_24px";
    HdsIconlibraryPoi_24px["AccommodationSolid_24px"] = "accommodation_solid_24px";
    HdsIconlibraryPoi_24px["AirportOutline_24px"] = "airport_outline_24px";
    HdsIconlibraryPoi_24px["AirportSolid_24px"] = "airport_solid_24px";
    HdsIconlibraryPoi_24px["AirportCargoOutline_24px"] = "airport-cargo_outline_24px";
    HdsIconlibraryPoi_24px["AirportCargoSolid_24px"] = "airport-cargo_solid_24px";
    HdsIconlibraryPoi_24px["AirportGateOutline_24px"] = "airport-gate_outline_24px";
    HdsIconlibraryPoi_24px["AirportGateSolid_24px"] = "airport-gate_solid_24px";
    HdsIconlibraryPoi_24px["AmusementParkOutline_24px"] = "amusement-park_outline_24px";
    HdsIconlibraryPoi_24px["AmusementParkSolid_24px"] = "amusement-park_solid_24px";
    HdsIconlibraryPoi_24px["AquariumOutline_24px"] = "aquarium_outline_24px";
    HdsIconlibraryPoi_24px["AquariumSolid_24px"] = "aquarium_solid_24px";
    HdsIconlibraryPoi_24px["ArtGalleryOutline_24px"] = "art-gallery_outline_24px";
    HdsIconlibraryPoi_24px["ArtGallerySolid_24px"] = "art-gallery_solid_24px";
    HdsIconlibraryPoi_24px["AshramOutline_24px"] = "ashram_outline_24px";
    HdsIconlibraryPoi_24px["AshramSolid_24px"] = "ashram_solid_24px";
    HdsIconlibraryPoi_24px["AtmOutline_24px"] = "atm_outline_24px";
    HdsIconlibraryPoi_24px["AtmSolid_24px"] = "atm_solid_24px";
    HdsIconlibraryPoi_24px["AttractionOutline_24px"] = "attraction_outline_24px";
    HdsIconlibraryPoi_24px["AttractionSolid_24px"] = "attraction_solid_24px";
    HdsIconlibraryPoi_24px["BakeryOutline_24px"] = "bakery_outline_24px";
    HdsIconlibraryPoi_24px["BakerySolid_24px"] = "bakery_solid_24px";
    HdsIconlibraryPoi_24px["BeachOutline_24px"] = "beach_outline_24px";
    HdsIconlibraryPoi_24px["BeachSolid_24px"] = "beach_solid_24px";
    HdsIconlibraryPoi_24px["BookstoreOutline_24px"] = "bookstore_outline_24px";
    HdsIconlibraryPoi_24px["BookstoreSolid_24px"] = "bookstore_solid_24px";
    HdsIconlibraryPoi_24px["BowlingOutline_24px"] = "bowling_outline_24px";
    HdsIconlibraryPoi_24px["BowlingSolid_24px"] = "bowling_solid_24px";
    HdsIconlibraryPoi_24px["BridgeOutline_24px"] = "bridge_outline_24px";
    HdsIconlibraryPoi_24px["BridgeSolid_24px"] = "bridge_solid_24px";
    HdsIconlibraryPoi_24px["BusOutline_24px"] = "bus_outline_24px";
    HdsIconlibraryPoi_24px["BusSolid_24px"] = "bus_solid_24px";
    HdsIconlibraryPoi_24px["BusinessOutline_24px"] = "business_outline_24px";
    HdsIconlibraryPoi_24px["BusinessSolid_24px"] = "business_solid_24px";
    HdsIconlibraryPoi_24px["BusinessPostJpnOutline_24px"] = "business-post-jpn_outline_24px";
    HdsIconlibraryPoi_24px["BusinessPostJpnSolid_24px"] = "business-post-jpn_solid_24px";
    HdsIconlibraryPoi_24px["ButcherOutline_24px"] = "butcher_outline_24px";
    HdsIconlibraryPoi_24px["ButcherSolid_24px"] = "butcher_solid_24px";
    HdsIconlibraryPoi_24px["CableWayOutline_24px"] = "cable-way_outline_24px";
    HdsIconlibraryPoi_24px["CableWaySolid_24px"] = "cable-way_solid_24px";
    HdsIconlibraryPoi_24px["CampingOutline_24px"] = "camping_outline_24px";
    HdsIconlibraryPoi_24px["CampingSolid_24px"] = "camping_solid_24px";
    HdsIconlibraryPoi_24px["CarChargingOutline_24px"] = "car-charging_outline_24px";
    HdsIconlibraryPoi_24px["CarChargingSolid_24px"] = "car-charging_solid_24px";
    HdsIconlibraryPoi_24px["CarChargingFastOutline_24px"] = "car-charging-fast_outline_24px";
    HdsIconlibraryPoi_24px["CarChargingFastSolid_24px"] = "car-charging-fast_solid_24px";
    HdsIconlibraryPoi_24px["CarDealershipOutline_24px"] = "car-dealership_outline_24px";
    HdsIconlibraryPoi_24px["CarDealershipSolid_24px"] = "car-dealership_solid_24px";
    HdsIconlibraryPoi_24px["CarElectricOutline_24px"] = "car-electric_outline_24px";
    HdsIconlibraryPoi_24px["CarElectricSolid_24px"] = "car-electric_solid_24px";
    HdsIconlibraryPoi_24px["CarRentalOutline_24px"] = "car-rental_outline_24px";
    HdsIconlibraryPoi_24px["CarRentalSolid_24px"] = "car-rental_solid_24px";
    HdsIconlibraryPoi_24px["CarRepairOutline_24px"] = "car-repair_outline_24px";
    HdsIconlibraryPoi_24px["CarRepairSolid_24px"] = "car-repair_solid_24px";
    HdsIconlibraryPoi_24px["CarWashOutline_24px"] = "car-wash_outline_24px";
    HdsIconlibraryPoi_24px["CarWashSolid_24px"] = "car-wash_solid_24px";
    HdsIconlibraryPoi_24px["CargoCenterOutline_24px"] = "cargo-center_outline_24px";
    HdsIconlibraryPoi_24px["CargoCenterSolid_24px"] = "cargo-center_solid_24px";
    HdsIconlibraryPoi_24px["CartOutline_24px"] = "cart_outline_24px";
    HdsIconlibraryPoi_24px["CartSolid_24px"] = "cart_solid_24px";
    HdsIconlibraryPoi_24px["CasinoOutline_24px"] = "casino_outline_24px";
    HdsIconlibraryPoi_24px["CasinoSolid_24px"] = "casino_solid_24px";
    HdsIconlibraryPoi_24px["CemetryOutline_24px"] = "cemetry_outline_24px";
    HdsIconlibraryPoi_24px["CemetrySolid_24px"] = "cemetry_solid_24px";
    HdsIconlibraryPoi_24px["ChurchOutline_24px"] = "church_outline_24px";
    HdsIconlibraryPoi_24px["ChurchSolid_24px"] = "church_solid_24px";
    HdsIconlibraryPoi_24px["CinemaOutline_24px"] = "cinema_outline_24px";
    HdsIconlibraryPoi_24px["CinemaSolid_24px"] = "cinema_solid_24px";
    HdsIconlibraryPoi_24px["ClothingOutline_24px"] = "clothing_outline_24px";
    HdsIconlibraryPoi_24px["ClothingSolid_24px"] = "clothing_solid_24px";
    HdsIconlibraryPoi_24px["CoachOutline_24px"] = "coach_outline_24px";
    HdsIconlibraryPoi_24px["CoachSolid_24px"] = "coach_solid_24px";
    HdsIconlibraryPoi_24px["CocktailOutline_24px"] = "cocktail_outline_24px";
    HdsIconlibraryPoi_24px["CocktailSolid_24px"] = "cocktail_solid_24px";
    HdsIconlibraryPoi_24px["CoffeeOutline_24px"] = "coffee_outline_24px";
    HdsIconlibraryPoi_24px["CoffeeSolid_24px"] = "coffee_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyBahtOutline_24px"] = "currency-baht_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyBahtSolid_24px"] = "currency-baht_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyDollarOutline_24px"] = "currency-dollar_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyDollarSolid_24px"] = "currency-dollar_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyDongOutline_24px"] = "currency-dong_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyDongSolid_24px"] = "currency-dong_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyEuroOutline_24px"] = "currency-euro_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyEuroSolid_24px"] = "currency-euro_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyFrancOutline_24px"] = "currency-franc_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyFrancSolid_24px"] = "currency-franc_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyKroneOutline_24px"] = "currency-krone_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyKroneSolid_24px"] = "currency-krone_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyLiraOutline_24px"] = "currency-lira_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyLiraSolid_24px"] = "currency-lira_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyNairaOutline_24px"] = "currency-naira_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyNairaSolid_24px"] = "currency-naira_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyPoundOutline_24px"] = "currency-pound_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyPoundSolid_24px"] = "currency-pound_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyRubleOutline_24px"] = "currency-ruble_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyRubleSolid_24px"] = "currency-ruble_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyRupeeOutline_24px"] = "currency-rupee_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyRupeeSolid_24px"] = "currency-rupee_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyRupeesOutline_24px"] = "currency-rupees_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyRupeesSolid_24px"] = "currency-rupees_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyRupiahOutline_24px"] = "currency-rupiah_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyRupiahSolid_24px"] = "currency-rupiah_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyShekelOutline_24px"] = "currency-shekel_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyShekelSolid_24px"] = "currency-shekel_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyTakaOutline_24px"] = "currency-taka_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyTakaSolid_24px"] = "currency-taka_solid_24px";
    HdsIconlibraryPoi_24px["CurrencyYenOutline_24px"] = "currency-yen_outline_24px";
    HdsIconlibraryPoi_24px["CurrencyYenSolid_24px"] = "currency-yen_solid_24px";
    HdsIconlibraryPoi_24px["DeliveryEntranceOutline_24px"] = "delivery-entrance_outline_24px";
    HdsIconlibraryPoi_24px["DeliveryEntranceSolid_24px"] = "delivery-entrance_solid_24px";
    HdsIconlibraryPoi_24px["DoughnutOutline_24px"] = "doughnut_outline_24px";
    HdsIconlibraryPoi_24px["DoughnutSolid_24px"] = "doughnut_solid_24px";
    HdsIconlibraryPoi_24px["EducationOutline_24px"] = "education_outline_24px";
    HdsIconlibraryPoi_24px["EducationSolid_24px"] = "education_solid_24px";
    HdsIconlibraryPoi_24px["ElevatorOutline_24px"] = "elevator_outline_24px";
    HdsIconlibraryPoi_24px["ElevatorSolid_24px"] = "elevator_solid_24px";
    HdsIconlibraryPoi_24px["EmergencyFiredepartmentJpnOutline_24px"] = "emergency-firedepartment-jpn_outline_24px";
    HdsIconlibraryPoi_24px["EmergencyFiredepartmentJpnSolid_24px"] = "emergency-firedepartment-jpn_solid_24px";
    HdsIconlibraryPoi_24px["EmergencyHospitalJpnOutline_24px"] = "emergency-hospital-jpn_outline_24px";
    HdsIconlibraryPoi_24px["EmergencyHospitalJpnSolid_24px"] = "emergency-hospital-jpn_solid_24px";
    HdsIconlibraryPoi_24px["EmergencyPoliceJpnOutline_24px"] = "emergency-police-jpn_outline_24px";
    HdsIconlibraryPoi_24px["EmergencyPoliceJpnSolid_24px"] = "emergency-police-jpn_solid_24px";
    HdsIconlibraryPoi_24px["EmergencyPoliceboxJpnOutline_24px"] = "emergency-policebox-jpn_outline_24px";
    HdsIconlibraryPoi_24px["EmergencyPoliceboxJpnSolid_24px"] = "emergency-policebox-jpn_solid_24px";
    HdsIconlibraryPoi_24px["EnterVenueOutline_24px"] = "enter-venue_outline_24px";
    HdsIconlibraryPoi_24px["EnterVenueSolid_24px"] = "enter-venue_solid_24px";
    HdsIconlibraryPoi_24px["EntranceOutline_24px"] = "entrance_outline_24px";
    HdsIconlibraryPoi_24px["EntranceSolid_24px"] = "entrance_solid_24px";
    HdsIconlibraryPoi_24px["EscalatorOutline_24px"] = "escalator_outline_24px";
    HdsIconlibraryPoi_24px["EscalatorSolid_24px"] = "escalator_solid_24px";
    HdsIconlibraryPoi_24px["ExhibitionCenterOutline_24px"] = "exhibition-center_outline_24px";
    HdsIconlibraryPoi_24px["ExhibitionCenterSolid_24px"] = "exhibition-center_solid_24px";
    HdsIconlibraryPoi_24px["FacilitiesOutline_24px"] = "facilities_outline_24px";
    HdsIconlibraryPoi_24px["FacilitiesSolid_24px"] = "facilities_solid_24px";
    HdsIconlibraryPoi_24px["FacilitiesCityhallJpnOutline_24px"] = "facilities-cityhall-jpn_outline_24px";
    HdsIconlibraryPoi_24px["FacilitiesCityhallJpnSolid_24px"] = "facilities-cityhall-jpn_solid_24px";
    HdsIconlibraryPoi_24px["FacilitiesEducationHigherJpnOutline_24px"] = "facilities-education-higher-jpn_outline_24px";
    HdsIconlibraryPoi_24px["FacilitiesEducationHigherJpnSolid_24px"] = "facilities-education-higher-jpn_solid_24px";
    HdsIconlibraryPoi_24px["FacilitiesEducationSchoolJpnOutline_24px"] = "facilities-education-school-jpn_outline_24px";
    HdsIconlibraryPoi_24px["FacilitiesEducationSchoolJpnSolid_24px"] = "facilities-education-school-jpn_solid_24px";
    HdsIconlibraryPoi_24px["FacilitiesOfficePrefecturalJpnOutline_24px"] = "facilities-office-prefectural-jpn_outline_24px";
    HdsIconlibraryPoi_24px["FacilitiesOfficePrefecturalJpnSolid_24px"] = "facilities-office-prefectural-jpn_solid_24px";
    HdsIconlibraryPoi_24px["FacilitiesOfficeTownvillageJpnOutline_24px"] = "facilities-office-townvillage-jpn_outline_24px";
    HdsIconlibraryPoi_24px["FacilitiesOfficeTownvillageJpnSolid_24px"] = "facilities-office-townvillage-jpn_solid_24px";
    HdsIconlibraryPoi_24px["FacilitiesOfficeWardJpnOutline_24px"] = "facilities-office-ward-jpn_outline_24px";
    HdsIconlibraryPoi_24px["FacilitiesOfficeWardJpnSolid_24px"] = "facilities-office-ward-jpn_solid_24px";
    HdsIconlibraryPoi_24px["FastFoodOutline_24px"] = "fast-food_outline_24px";
    HdsIconlibraryPoi_24px["FastFoodSolid_24px"] = "fast-food_solid_24px";
    HdsIconlibraryPoi_24px["FerryOutline_24px"] = "ferry_outline_24px";
    HdsIconlibraryPoi_24px["FerrySolid_24px"] = "ferry_solid_24px";
    HdsIconlibraryPoi_24px["FireDepartmentOutline_24px"] = "fire-department_outline_24px";
    HdsIconlibraryPoi_24px["FireDepartmentSolid_24px"] = "fire-department_solid_24px";
    HdsIconlibraryPoi_24px["FirstAidCrescentOutline_24px"] = "first-aid-crescent_outline_24px";
    HdsIconlibraryPoi_24px["FirstAidCrescentSolid_24px"] = "first-aid-crescent_solid_24px";
    HdsIconlibraryPoi_24px["FirstAidCrossOutline_24px"] = "first-aid-cross_outline_24px";
    HdsIconlibraryPoi_24px["FirstAidCrossSolid_24px"] = "first-aid-cross_solid_24px";
    HdsIconlibraryPoi_24px["FitnessOutline_24px"] = "fitness_outline_24px";
    HdsIconlibraryPoi_24px["FitnessSolid_24px"] = "fitness_solid_24px";
    HdsIconlibraryPoi_24px["FrontierCrossingOutline_24px"] = "frontier-crossing_outline_24px";
    HdsIconlibraryPoi_24px["FrontierCrossingSolid_24px"] = "frontier-crossing_solid_24px";
    HdsIconlibraryPoi_24px["GameArcadeOutline_24px"] = "game-arcade_outline_24px";
    HdsIconlibraryPoi_24px["GameArcadeSolid_24px"] = "game-arcade_solid_24px";
    HdsIconlibraryPoi_24px["GolfCourseOutline_24px"] = "golf-course_outline_24px";
    HdsIconlibraryPoi_24px["GolfCourseSolid_24px"] = "golf-course_solid_24px";
    HdsIconlibraryPoi_24px["GroceryOutline_24px"] = "grocery_outline_24px";
    HdsIconlibraryPoi_24px["GrocerySolid_24px"] = "grocery_solid_24px";
    HdsIconlibraryPoi_24px["GurdwaraOutline_24px"] = "gurdwara_outline_24px";
    HdsIconlibraryPoi_24px["GurdwaraSolid_24px"] = "gurdwara_solid_24px";
    HdsIconlibraryPoi_24px["HarborOutline_24px"] = "harbor_outline_24px";
    HdsIconlibraryPoi_24px["HarborSolid_24px"] = "harbor_solid_24px";
    HdsIconlibraryPoi_24px["HospitalCrescentOutline_24px"] = "hospital-crescent_outline_24px";
    HdsIconlibraryPoi_24px["HospitalCrescentSolid_24px"] = "hospital-crescent_solid_24px";
    HdsIconlibraryPoi_24px["HospitalCrossOutline_24px"] = "hospital-cross_outline_24px";
    HdsIconlibraryPoi_24px["HospitalCrossSolid_24px"] = "hospital-cross_solid_24px";
    HdsIconlibraryPoi_24px["HotSpringJpnOutline_24px"] = "hot-spring-jpn_outline_24px";
    HdsIconlibraryPoi_24px["HotSpringJpnSolid_24px"] = "hot-spring-jpn_solid_24px";
    HdsIconlibraryPoi_24px["HotelOutline_24px"] = "hotel_outline_24px";
    HdsIconlibraryPoi_24px["HotelSolid_24px"] = "hotel_solid_24px";
    HdsIconlibraryPoi_24px["InclinedOutline_24px"] = "inclined_outline_24px";
    HdsIconlibraryPoi_24px["InclinedSolid_24px"] = "inclined_solid_24px";
    HdsIconlibraryPoi_24px["IndustrialComplexOutline_24px"] = "industrial-complex_outline_24px";
    HdsIconlibraryPoi_24px["IndustrialComplexSolid_24px"] = "industrial-complex_solid_24px";
    HdsIconlibraryPoi_24px["KaraokeOutline_24px"] = "karaoke_outline_24px";
    HdsIconlibraryPoi_24px["KaraokeSolid_24px"] = "karaoke_solid_24px";
    HdsIconlibraryPoi_24px["LaundryOutline_24px"] = "laundry_outline_24px";
    HdsIconlibraryPoi_24px["LaundrySolid_24px"] = "laundry_solid_24px";
    HdsIconlibraryPoi_24px["LibraryOutline_24px"] = "library_outline_24px";
    HdsIconlibraryPoi_24px["LibrarySolid_24px"] = "library_solid_24px";
    HdsIconlibraryPoi_24px["LiquorOutline_24px"] = "liquor_outline_24px";
    HdsIconlibraryPoi_24px["LiquorSolid_24px"] = "liquor_solid_24px";
    HdsIconlibraryPoi_24px["LoadingDockOutline_24px"] = "loading-dock_outline_24px";
    HdsIconlibraryPoi_24px["LoadingDockSolid_24px"] = "loading-dock_solid_24px";
    HdsIconlibraryPoi_24px["MetroOutline_24px"] = "metro_outline_24px";
    HdsIconlibraryPoi_24px["MetroSolid_24px"] = "metro_solid_24px";
    HdsIconlibraryPoi_24px["MonorailOutline_24px"] = "monorail_outline_24px";
    HdsIconlibraryPoi_24px["MonorailSolid_24px"] = "monorail_solid_24px";
    HdsIconlibraryPoi_24px["MosqueOutline_24px"] = "mosque_outline_24px";
    HdsIconlibraryPoi_24px["MosqueSolid_24px"] = "mosque_solid_24px";
    HdsIconlibraryPoi_24px["MountainOutline_24px"] = "mountain_outline_24px";
    HdsIconlibraryPoi_24px["MountainSolid_24px"] = "mountain_solid_24px";
    HdsIconlibraryPoi_24px["MountainPassOutline_24px"] = "mountain-pass_outline_24px";
    HdsIconlibraryPoi_24px["MountainPassSolid_24px"] = "mountain-pass_solid_24px";
    HdsIconlibraryPoi_24px["MuseumOutline_24px"] = "museum_outline_24px";
    HdsIconlibraryPoi_24px["MuseumSolid_24px"] = "museum_solid_24px";
    HdsIconlibraryPoi_24px["MuseumArtOutline_24px"] = "museum-art_outline_24px";
    HdsIconlibraryPoi_24px["MuseumArtSolid_24px"] = "museum-art_solid_24px";
    HdsIconlibraryPoi_24px["NatureOutline_24px"] = "nature_outline_24px";
    HdsIconlibraryPoi_24px["NatureSolid_24px"] = "nature_solid_24px";
    HdsIconlibraryPoi_24px["NatureOverlookOutline_24px"] = "nature-overlook_outline_24px";
    HdsIconlibraryPoi_24px["NatureOverlookSolid_24px"] = "nature-overlook_solid_24px";
    HdsIconlibraryPoi_24px["NightClubOutline_24px"] = "night-club_outline_24px";
    HdsIconlibraryPoi_24px["NightClubSolid_24px"] = "night-club_solid_24px";
    HdsIconlibraryPoi_24px["PagodaOutline_24px"] = "pagoda_outline_24px";
    HdsIconlibraryPoi_24px["PagodaSolid_24px"] = "pagoda_solid_24px";
    HdsIconlibraryPoi_24px["ParkAndRideOutline_24px"] = "park-and-ride_outline_24px";
    HdsIconlibraryPoi_24px["ParkAndRideSolid_24px"] = "park-and-ride_solid_24px";
    HdsIconlibraryPoi_24px["ParkingOutline_24px"] = "parking_outline_24px";
    HdsIconlibraryPoi_24px["ParkingSolid_24px"] = "parking_solid_24px";
    HdsIconlibraryPoi_24px["ParkingBicycleOutline_24px"] = "parking-bicycle_outline_24px";
    HdsIconlibraryPoi_24px["ParkingBicycleSolid_24px"] = "parking-bicycle_solid_24px";
    HdsIconlibraryPoi_24px["ParkingGarageOutline_24px"] = "parking-garage_outline_24px";
    HdsIconlibraryPoi_24px["ParkingGarageSolid_24px"] = "parking-garage_solid_24px";
    HdsIconlibraryPoi_24px["ParkingMotorcycleOutline_24px"] = "parking-motorcycle_outline_24px";
    HdsIconlibraryPoi_24px["ParkingMotorcycleSolid_24px"] = "parking-motorcycle_solid_24px";
    HdsIconlibraryPoi_24px["PetrolStationOutline_24px"] = "petrol-station_outline_24px";
    HdsIconlibraryPoi_24px["PetrolStationSolid_24px"] = "petrol-station_solid_24px";
    HdsIconlibraryPoi_24px["PharmacyCrescentOutline_24px"] = "pharmacy-crescent_outline_24px";
    HdsIconlibraryPoi_24px["PharmacyCrescentSolid_24px"] = "pharmacy-crescent_solid_24px";
    HdsIconlibraryPoi_24px["PharmacyCrossOutline_24px"] = "pharmacy-cross_outline_24px";
    HdsIconlibraryPoi_24px["PharmacyCrossSolid_24px"] = "pharmacy-cross_solid_24px";
    HdsIconlibraryPoi_24px["PicnicAreaOutline_24px"] = "picnic-area_outline_24px";
    HdsIconlibraryPoi_24px["PicnicAreaSolid_24px"] = "picnic-area_solid_24px";
    HdsIconlibraryPoi_24px["PlaygroundOutline_24px"] = "playground_outline_24px";
    HdsIconlibraryPoi_24px["PlaygroundSolid_24px"] = "playground_solid_24px";
    HdsIconlibraryPoi_24px["PointOutline_24px"] = "point_outline_24px";
    HdsIconlibraryPoi_24px["PointSolid_24px"] = "point_solid_24px";
    HdsIconlibraryPoi_24px["PoliceOutline_24px"] = "police_outline_24px";
    HdsIconlibraryPoi_24px["PoliceSolid_24px"] = "police_solid_24px";
    HdsIconlibraryPoi_24px["PoolOutline_24px"] = "pool_outline_24px";
    HdsIconlibraryPoi_24px["PoolSolid_24px"] = "pool_solid_24px";
    HdsIconlibraryPoi_24px["PostOutline_24px"] = "post_outline_24px";
    HdsIconlibraryPoi_24px["PostSolid_24px"] = "post_solid_24px";
    HdsIconlibraryPoi_24px["PubOutline_24px"] = "pub_outline_24px";
    HdsIconlibraryPoi_24px["PubSolid_24px"] = "pub_solid_24px";
    HdsIconlibraryPoi_24px["PublicToiletOutline_24px"] = "public-toilet_outline_24px";
    HdsIconlibraryPoi_24px["PublicToiletSolid_24px"] = "public-toilet_solid_24px";
    HdsIconlibraryPoi_24px["PublicTransportOutline_24px"] = "public-transport_outline_24px";
    HdsIconlibraryPoi_24px["PublicTransportSolid_24px"] = "public-transport_solid_24px";
    HdsIconlibraryPoi_24px["RailLightOutline_24px"] = "rail-light_outline_24px";
    HdsIconlibraryPoi_24px["RailLightSolid_24px"] = "rail-light_solid_24px";
    HdsIconlibraryPoi_24px["RailRegionalOutline_24px"] = "rail-regional_outline_24px";
    HdsIconlibraryPoi_24px["RailRegionalSolid_24px"] = "rail-regional_solid_24px";
    HdsIconlibraryPoi_24px["RailYardOutline_24px"] = "rail-yard_outline_24px";
    HdsIconlibraryPoi_24px["RailYardSolid_24px"] = "rail-yard_solid_24px";
    HdsIconlibraryPoi_24px["RampOutline_24px"] = "ramp_outline_24px";
    HdsIconlibraryPoi_24px["RampSolid_24px"] = "ramp_solid_24px";
    HdsIconlibraryPoi_24px["ReligiousPlaceOutline_24px"] = "religious-place_outline_24px";
    HdsIconlibraryPoi_24px["ReligiousPlaceSolid_24px"] = "religious-place_solid_24px";
    HdsIconlibraryPoi_24px["ReligiousShintoJpnOutline_24px"] = "religious-shinto-jpn_outline_24px";
    HdsIconlibraryPoi_24px["ReligiousShintoJpnSolid_24px"] = "religious-shinto-jpn_solid_24px";
    HdsIconlibraryPoi_24px["ReligiousTempleBuddhistJpnOutline_24px"] = "religious-temple-buddhist-jpn_outline_24px";
    HdsIconlibraryPoi_24px["ReligiousTempleBuddhistJpnSolid_24px"] = "religious-temple-buddhist-jpn_solid_24px";
    HdsIconlibraryPoi_24px["RestaurantOutline_24px"] = "restaurant_outline_24px";
    HdsIconlibraryPoi_24px["RestaurantSolid_24px"] = "restaurant_solid_24px";
    HdsIconlibraryPoi_24px["SeaportHarborOutline_24px"] = "seaport-harbor_outline_24px";
    HdsIconlibraryPoi_24px["SeaportHarborSolid_24px"] = "seaport-harbor_solid_24px";
    HdsIconlibraryPoi_24px["ShoesOutline_24px"] = "shoes_outline_24px";
    HdsIconlibraryPoi_24px["ShoesSolid_24px"] = "shoes_solid_24px";
    HdsIconlibraryPoi_24px["ShoppingOutline_24px"] = "shopping_outline_24px";
    HdsIconlibraryPoi_24px["ShoppingSolid_24px"] = "shopping_solid_24px";
    HdsIconlibraryPoi_24px["ShrineGenericOutline_24px"] = "shrine-generic_outline_24px";
    HdsIconlibraryPoi_24px["ShrineGenericSolid_24px"] = "shrine-generic_solid_24px";
    HdsIconlibraryPoi_24px["SkiRunOutline_24px"] = "ski-run_outline_24px";
    HdsIconlibraryPoi_24px["SkiRunSolid_24px"] = "ski-run_solid_24px";
    HdsIconlibraryPoi_24px["SkywalkOutline_24px"] = "skywalk_outline_24px";
    HdsIconlibraryPoi_24px["SkywalkSolid_24px"] = "skywalk_solid_24px";
    HdsIconlibraryPoi_24px["StadiumOutline_24px"] = "stadium_outline_24px";
    HdsIconlibraryPoi_24px["StadiumSolid_24px"] = "stadium_solid_24px";
    HdsIconlibraryPoi_24px["StairsOutline_24px"] = "stairs_outline_24px";
    HdsIconlibraryPoi_24px["StairsSolid_24px"] = "stairs_solid_24px";
    HdsIconlibraryPoi_24px["SweetsOutline_24px"] = "sweets_outline_24px";
    HdsIconlibraryPoi_24px["SweetsSolid_24px"] = "sweets_solid_24px";
    HdsIconlibraryPoi_24px["SwimmingOutline_24px"] = "swimming_outline_24px";
    HdsIconlibraryPoi_24px["SwimmingSolid_24px"] = "swimming_solid_24px";
    HdsIconlibraryPoi_24px["SynagogueOutline_24px"] = "synagogue_outline_24px";
    HdsIconlibraryPoi_24px["SynagogueSolid_24px"] = "synagogue_solid_24px";
    HdsIconlibraryPoi_24px["TaxiOutline_24px"] = "taxi_outline_24px";
    HdsIconlibraryPoi_24px["TaxiSolid_24px"] = "taxi_solid_24px";
    HdsIconlibraryPoi_24px["TheaterOutline_24px"] = "theater_outline_24px";
    HdsIconlibraryPoi_24px["TheaterSolid_24px"] = "theater_solid_24px";
    HdsIconlibraryPoi_24px["TollBoothOutline_24px"] = "toll-booth_outline_24px";
    HdsIconlibraryPoi_24px["TollBoothSolid_24px"] = "toll-booth_solid_24px";
    HdsIconlibraryPoi_24px["TouristInformationOutline_24px"] = "tourist-information_outline_24px";
    HdsIconlibraryPoi_24px["TouristInformationSolid_24px"] = "tourist-information_solid_24px";
    HdsIconlibraryPoi_24px["TrainOutline_24px"] = "train_outline_24px";
    HdsIconlibraryPoi_24px["TrainSolid_24px"] = "train_solid_24px";
    HdsIconlibraryPoi_24px["TransportShinkansenJpnOutline_24px"] = "transport-shinkansen-jpn_outline_24px";
    HdsIconlibraryPoi_24px["TransportShinkansenJpnSolid_24px"] = "transport-shinkansen-jpn_solid_24px";
    HdsIconlibraryPoi_24px["TravelAgentTicketingOutline_24px"] = "travel-agent-ticketing_outline_24px";
    HdsIconlibraryPoi_24px["TravelAgentTicketingSolid_24px"] = "travel-agent-ticketing_solid_24px";
    HdsIconlibraryPoi_24px["TruckDealershipOutline_24px"] = "truck-dealership_outline_24px";
    HdsIconlibraryPoi_24px["TruckDealershipSolid_24px"] = "truck-dealership_solid_24px";
    HdsIconlibraryPoi_24px["TruckParkingOutline_24px"] = "truck-parking_outline_24px";
    HdsIconlibraryPoi_24px["TruckParkingSolid_24px"] = "truck-parking_solid_24px";
    HdsIconlibraryPoi_24px["TruckRepairOutline_24px"] = "truck-repair_outline_24px";
    HdsIconlibraryPoi_24px["TruckRepairSolid_24px"] = "truck-repair_solid_24px";
    HdsIconlibraryPoi_24px["TruckStopPlazaOutline_24px"] = "truck-stop-plaza_outline_24px";
    HdsIconlibraryPoi_24px["TruckStopPlazaSolid_24px"] = "truck-stop-plaza_solid_24px";
    HdsIconlibraryPoi_24px["TruckWashOutline_24px"] = "truck-wash_outline_24px";
    HdsIconlibraryPoi_24px["TruckWashSolid_24px"] = "truck-wash_solid_24px";
    HdsIconlibraryPoi_24px["TunnelOutline_24px"] = "tunnel_outline_24px";
    HdsIconlibraryPoi_24px["TunnelSolid_24px"] = "tunnel_solid_24px";
    HdsIconlibraryPoi_24px["WaterfallOutline_24px"] = "waterfall_outline_24px";
    HdsIconlibraryPoi_24px["WaterfallSolid_24px"] = "waterfall_solid_24px";
    HdsIconlibraryPoi_24px["WeighStationOutline_24px"] = "weigh-station_outline_24px";
    HdsIconlibraryPoi_24px["WeighStationSolid_24px"] = "weigh-station_solid_24px";
    HdsIconlibraryPoi_24px["ZooOutline_24px"] = "zoo_outline_24px";
    HdsIconlibraryPoi_24px["ZooSolid_24px"] = "zoo_solid_24px";
})(HdsIconlibraryPoi_24px = HdsIconlibraryPoi_24px || (HdsIconlibraryPoi_24px = {}));
export const HDS_ICONLIBRARY_POI_24PX_CODEPOINTS = {
    [HdsIconlibraryPoi_24px.AccommodationOutline_24px]: '61697',
    [HdsIconlibraryPoi_24px.AccommodationSolid_24px]: '61698',
    [HdsIconlibraryPoi_24px.AirportOutline_24px]: '61699',
    [HdsIconlibraryPoi_24px.AirportSolid_24px]: '61700',
    [HdsIconlibraryPoi_24px.AirportCargoOutline_24px]: '61701',
    [HdsIconlibraryPoi_24px.AirportCargoSolid_24px]: '61702',
    [HdsIconlibraryPoi_24px.AirportGateOutline_24px]: '61703',
    [HdsIconlibraryPoi_24px.AirportGateSolid_24px]: '61704',
    [HdsIconlibraryPoi_24px.AmusementParkOutline_24px]: '61705',
    [HdsIconlibraryPoi_24px.AmusementParkSolid_24px]: '61706',
    [HdsIconlibraryPoi_24px.AquariumOutline_24px]: '61707',
    [HdsIconlibraryPoi_24px.AquariumSolid_24px]: '61708',
    [HdsIconlibraryPoi_24px.ArtGalleryOutline_24px]: '61709',
    [HdsIconlibraryPoi_24px.ArtGallerySolid_24px]: '61710',
    [HdsIconlibraryPoi_24px.AshramOutline_24px]: '61711',
    [HdsIconlibraryPoi_24px.AshramSolid_24px]: '61712',
    [HdsIconlibraryPoi_24px.AtmOutline_24px]: '61713',
    [HdsIconlibraryPoi_24px.AtmSolid_24px]: '61714',
    [HdsIconlibraryPoi_24px.AttractionOutline_24px]: '61715',
    [HdsIconlibraryPoi_24px.AttractionSolid_24px]: '61716',
    [HdsIconlibraryPoi_24px.BakeryOutline_24px]: '61717',
    [HdsIconlibraryPoi_24px.BakerySolid_24px]: '61718',
    [HdsIconlibraryPoi_24px.BeachOutline_24px]: '61719',
    [HdsIconlibraryPoi_24px.BeachSolid_24px]: '61720',
    [HdsIconlibraryPoi_24px.BookstoreOutline_24px]: '61721',
    [HdsIconlibraryPoi_24px.BookstoreSolid_24px]: '61722',
    [HdsIconlibraryPoi_24px.BowlingOutline_24px]: '61723',
    [HdsIconlibraryPoi_24px.BowlingSolid_24px]: '61724',
    [HdsIconlibraryPoi_24px.BridgeOutline_24px]: '61725',
    [HdsIconlibraryPoi_24px.BridgeSolid_24px]: '61726',
    [HdsIconlibraryPoi_24px.BusOutline_24px]: '61727',
    [HdsIconlibraryPoi_24px.BusSolid_24px]: '61728',
    [HdsIconlibraryPoi_24px.BusinessOutline_24px]: '61729',
    [HdsIconlibraryPoi_24px.BusinessSolid_24px]: '61730',
    [HdsIconlibraryPoi_24px.BusinessPostJpnOutline_24px]: '61731',
    [HdsIconlibraryPoi_24px.BusinessPostJpnSolid_24px]: '61732',
    [HdsIconlibraryPoi_24px.ButcherOutline_24px]: '61733',
    [HdsIconlibraryPoi_24px.ButcherSolid_24px]: '61734',
    [HdsIconlibraryPoi_24px.CableWayOutline_24px]: '61735',
    [HdsIconlibraryPoi_24px.CableWaySolid_24px]: '61736',
    [HdsIconlibraryPoi_24px.CampingOutline_24px]: '61737',
    [HdsIconlibraryPoi_24px.CampingSolid_24px]: '61738',
    [HdsIconlibraryPoi_24px.CarChargingOutline_24px]: '61739',
    [HdsIconlibraryPoi_24px.CarChargingSolid_24px]: '61740',
    [HdsIconlibraryPoi_24px.CarChargingFastOutline_24px]: '61741',
    [HdsIconlibraryPoi_24px.CarChargingFastSolid_24px]: '61742',
    [HdsIconlibraryPoi_24px.CarDealershipOutline_24px]: '61743',
    [HdsIconlibraryPoi_24px.CarDealershipSolid_24px]: '61744',
    [HdsIconlibraryPoi_24px.CarElectricOutline_24px]: '61745',
    [HdsIconlibraryPoi_24px.CarElectricSolid_24px]: '61746',
    [HdsIconlibraryPoi_24px.CarRentalOutline_24px]: '61747',
    [HdsIconlibraryPoi_24px.CarRentalSolid_24px]: '61748',
    [HdsIconlibraryPoi_24px.CarRepairOutline_24px]: '61749',
    [HdsIconlibraryPoi_24px.CarRepairSolid_24px]: '61750',
    [HdsIconlibraryPoi_24px.CarWashOutline_24px]: '61751',
    [HdsIconlibraryPoi_24px.CarWashSolid_24px]: '61752',
    [HdsIconlibraryPoi_24px.CargoCenterOutline_24px]: '61753',
    [HdsIconlibraryPoi_24px.CargoCenterSolid_24px]: '61754',
    [HdsIconlibraryPoi_24px.CartOutline_24px]: '61755',
    [HdsIconlibraryPoi_24px.CartSolid_24px]: '61756',
    [HdsIconlibraryPoi_24px.CasinoOutline_24px]: '61757',
    [HdsIconlibraryPoi_24px.CasinoSolid_24px]: '61758',
    [HdsIconlibraryPoi_24px.CemetryOutline_24px]: '61759',
    [HdsIconlibraryPoi_24px.CemetrySolid_24px]: '61760',
    [HdsIconlibraryPoi_24px.ChurchOutline_24px]: '61761',
    [HdsIconlibraryPoi_24px.ChurchSolid_24px]: '61762',
    [HdsIconlibraryPoi_24px.CinemaOutline_24px]: '61763',
    [HdsIconlibraryPoi_24px.CinemaSolid_24px]: '61764',
    [HdsIconlibraryPoi_24px.ClothingOutline_24px]: '61765',
    [HdsIconlibraryPoi_24px.ClothingSolid_24px]: '61766',
    [HdsIconlibraryPoi_24px.CoachOutline_24px]: '61767',
    [HdsIconlibraryPoi_24px.CoachSolid_24px]: '61768',
    [HdsIconlibraryPoi_24px.CocktailOutline_24px]: '61769',
    [HdsIconlibraryPoi_24px.CocktailSolid_24px]: '61770',
    [HdsIconlibraryPoi_24px.CoffeeOutline_24px]: '61771',
    [HdsIconlibraryPoi_24px.CoffeeSolid_24px]: '61772',
    [HdsIconlibraryPoi_24px.CurrencyBahtOutline_24px]: '61773',
    [HdsIconlibraryPoi_24px.CurrencyBahtSolid_24px]: '61774',
    [HdsIconlibraryPoi_24px.CurrencyDollarOutline_24px]: '61775',
    [HdsIconlibraryPoi_24px.CurrencyDollarSolid_24px]: '61776',
    [HdsIconlibraryPoi_24px.CurrencyDongOutline_24px]: '61777',
    [HdsIconlibraryPoi_24px.CurrencyDongSolid_24px]: '61778',
    [HdsIconlibraryPoi_24px.CurrencyEuroOutline_24px]: '61779',
    [HdsIconlibraryPoi_24px.CurrencyEuroSolid_24px]: '61780',
    [HdsIconlibraryPoi_24px.CurrencyFrancOutline_24px]: '61781',
    [HdsIconlibraryPoi_24px.CurrencyFrancSolid_24px]: '61782',
    [HdsIconlibraryPoi_24px.CurrencyKroneOutline_24px]: '61783',
    [HdsIconlibraryPoi_24px.CurrencyKroneSolid_24px]: '61784',
    [HdsIconlibraryPoi_24px.CurrencyLiraOutline_24px]: '61785',
    [HdsIconlibraryPoi_24px.CurrencyLiraSolid_24px]: '61786',
    [HdsIconlibraryPoi_24px.CurrencyNairaOutline_24px]: '61787',
    [HdsIconlibraryPoi_24px.CurrencyNairaSolid_24px]: '61788',
    [HdsIconlibraryPoi_24px.CurrencyPoundOutline_24px]: '61789',
    [HdsIconlibraryPoi_24px.CurrencyPoundSolid_24px]: '61790',
    [HdsIconlibraryPoi_24px.CurrencyRubleOutline_24px]: '61791',
    [HdsIconlibraryPoi_24px.CurrencyRubleSolid_24px]: '61792',
    [HdsIconlibraryPoi_24px.CurrencyRupeeOutline_24px]: '61793',
    [HdsIconlibraryPoi_24px.CurrencyRupeeSolid_24px]: '61794',
    [HdsIconlibraryPoi_24px.CurrencyRupeesOutline_24px]: '61795',
    [HdsIconlibraryPoi_24px.CurrencyRupeesSolid_24px]: '61796',
    [HdsIconlibraryPoi_24px.CurrencyRupiahOutline_24px]: '61797',
    [HdsIconlibraryPoi_24px.CurrencyRupiahSolid_24px]: '61798',
    [HdsIconlibraryPoi_24px.CurrencyShekelOutline_24px]: '61799',
    [HdsIconlibraryPoi_24px.CurrencyShekelSolid_24px]: '61800',
    [HdsIconlibraryPoi_24px.CurrencyTakaOutline_24px]: '61801',
    [HdsIconlibraryPoi_24px.CurrencyTakaSolid_24px]: '61802',
    [HdsIconlibraryPoi_24px.CurrencyYenOutline_24px]: '61803',
    [HdsIconlibraryPoi_24px.CurrencyYenSolid_24px]: '61804',
    [HdsIconlibraryPoi_24px.DeliveryEntranceOutline_24px]: '61805',
    [HdsIconlibraryPoi_24px.DeliveryEntranceSolid_24px]: '61806',
    [HdsIconlibraryPoi_24px.DoughnutOutline_24px]: '61807',
    [HdsIconlibraryPoi_24px.DoughnutSolid_24px]: '61808',
    [HdsIconlibraryPoi_24px.EducationOutline_24px]: '61809',
    [HdsIconlibraryPoi_24px.EducationSolid_24px]: '61810',
    [HdsIconlibraryPoi_24px.ElevatorOutline_24px]: '61811',
    [HdsIconlibraryPoi_24px.ElevatorSolid_24px]: '61812',
    [HdsIconlibraryPoi_24px.EmergencyFiredepartmentJpnOutline_24px]: '61813',
    [HdsIconlibraryPoi_24px.EmergencyFiredepartmentJpnSolid_24px]: '61814',
    [HdsIconlibraryPoi_24px.EmergencyHospitalJpnOutline_24px]: '61815',
    [HdsIconlibraryPoi_24px.EmergencyHospitalJpnSolid_24px]: '61816',
    [HdsIconlibraryPoi_24px.EmergencyPoliceJpnOutline_24px]: '61817',
    [HdsIconlibraryPoi_24px.EmergencyPoliceJpnSolid_24px]: '61818',
    [HdsIconlibraryPoi_24px.EmergencyPoliceboxJpnOutline_24px]: '61819',
    [HdsIconlibraryPoi_24px.EmergencyPoliceboxJpnSolid_24px]: '61820',
    [HdsIconlibraryPoi_24px.EnterVenueOutline_24px]: '61821',
    [HdsIconlibraryPoi_24px.EnterVenueSolid_24px]: '61822',
    [HdsIconlibraryPoi_24px.EntranceOutline_24px]: '61823',
    [HdsIconlibraryPoi_24px.EntranceSolid_24px]: '61824',
    [HdsIconlibraryPoi_24px.EscalatorOutline_24px]: '61825',
    [HdsIconlibraryPoi_24px.EscalatorSolid_24px]: '61826',
    [HdsIconlibraryPoi_24px.ExhibitionCenterOutline_24px]: '61827',
    [HdsIconlibraryPoi_24px.ExhibitionCenterSolid_24px]: '61828',
    [HdsIconlibraryPoi_24px.FacilitiesOutline_24px]: '61829',
    [HdsIconlibraryPoi_24px.FacilitiesSolid_24px]: '61830',
    [HdsIconlibraryPoi_24px.FacilitiesCityhallJpnOutline_24px]: '61831',
    [HdsIconlibraryPoi_24px.FacilitiesCityhallJpnSolid_24px]: '61832',
    [HdsIconlibraryPoi_24px.FacilitiesEducationHigherJpnOutline_24px]: '61833',
    [HdsIconlibraryPoi_24px.FacilitiesEducationHigherJpnSolid_24px]: '61834',
    [HdsIconlibraryPoi_24px.FacilitiesEducationSchoolJpnOutline_24px]: '61835',
    [HdsIconlibraryPoi_24px.FacilitiesEducationSchoolJpnSolid_24px]: '61836',
    [HdsIconlibraryPoi_24px.FacilitiesOfficePrefecturalJpnOutline_24px]: '61837',
    [HdsIconlibraryPoi_24px.FacilitiesOfficePrefecturalJpnSolid_24px]: '61838',
    [HdsIconlibraryPoi_24px.FacilitiesOfficeTownvillageJpnOutline_24px]: '61839',
    [HdsIconlibraryPoi_24px.FacilitiesOfficeTownvillageJpnSolid_24px]: '61840',
    [HdsIconlibraryPoi_24px.FacilitiesOfficeWardJpnOutline_24px]: '61841',
    [HdsIconlibraryPoi_24px.FacilitiesOfficeWardJpnSolid_24px]: '61842',
    [HdsIconlibraryPoi_24px.FastFoodOutline_24px]: '61843',
    [HdsIconlibraryPoi_24px.FastFoodSolid_24px]: '61844',
    [HdsIconlibraryPoi_24px.FerryOutline_24px]: '61845',
    [HdsIconlibraryPoi_24px.FerrySolid_24px]: '61846',
    [HdsIconlibraryPoi_24px.FireDepartmentOutline_24px]: '61847',
    [HdsIconlibraryPoi_24px.FireDepartmentSolid_24px]: '61848',
    [HdsIconlibraryPoi_24px.FirstAidCrescentOutline_24px]: '61849',
    [HdsIconlibraryPoi_24px.FirstAidCrescentSolid_24px]: '61850',
    [HdsIconlibraryPoi_24px.FirstAidCrossOutline_24px]: '61851',
    [HdsIconlibraryPoi_24px.FirstAidCrossSolid_24px]: '61852',
    [HdsIconlibraryPoi_24px.FitnessOutline_24px]: '61853',
    [HdsIconlibraryPoi_24px.FitnessSolid_24px]: '61854',
    [HdsIconlibraryPoi_24px.FrontierCrossingOutline_24px]: '61855',
    [HdsIconlibraryPoi_24px.FrontierCrossingSolid_24px]: '61856',
    [HdsIconlibraryPoi_24px.GameArcadeOutline_24px]: '61857',
    [HdsIconlibraryPoi_24px.GameArcadeSolid_24px]: '61858',
    [HdsIconlibraryPoi_24px.GolfCourseOutline_24px]: '61859',
    [HdsIconlibraryPoi_24px.GolfCourseSolid_24px]: '61860',
    [HdsIconlibraryPoi_24px.GroceryOutline_24px]: '61861',
    [HdsIconlibraryPoi_24px.GrocerySolid_24px]: '61862',
    [HdsIconlibraryPoi_24px.GurdwaraOutline_24px]: '61863',
    [HdsIconlibraryPoi_24px.GurdwaraSolid_24px]: '61864',
    [HdsIconlibraryPoi_24px.HarborOutline_24px]: '61865',
    [HdsIconlibraryPoi_24px.HarborSolid_24px]: '61866',
    [HdsIconlibraryPoi_24px.HospitalCrescentOutline_24px]: '61867',
    [HdsIconlibraryPoi_24px.HospitalCrescentSolid_24px]: '61868',
    [HdsIconlibraryPoi_24px.HospitalCrossOutline_24px]: '61869',
    [HdsIconlibraryPoi_24px.HospitalCrossSolid_24px]: '61870',
    [HdsIconlibraryPoi_24px.HotSpringJpnOutline_24px]: '61871',
    [HdsIconlibraryPoi_24px.HotSpringJpnSolid_24px]: '61872',
    [HdsIconlibraryPoi_24px.HotelOutline_24px]: '61873',
    [HdsIconlibraryPoi_24px.HotelSolid_24px]: '61874',
    [HdsIconlibraryPoi_24px.InclinedOutline_24px]: '61875',
    [HdsIconlibraryPoi_24px.InclinedSolid_24px]: '61876',
    [HdsIconlibraryPoi_24px.IndustrialComplexOutline_24px]: '61877',
    [HdsIconlibraryPoi_24px.IndustrialComplexSolid_24px]: '61878',
    [HdsIconlibraryPoi_24px.KaraokeOutline_24px]: '61879',
    [HdsIconlibraryPoi_24px.KaraokeSolid_24px]: '61880',
    [HdsIconlibraryPoi_24px.LaundryOutline_24px]: '61881',
    [HdsIconlibraryPoi_24px.LaundrySolid_24px]: '61882',
    [HdsIconlibraryPoi_24px.LibraryOutline_24px]: '61883',
    [HdsIconlibraryPoi_24px.LibrarySolid_24px]: '61884',
    [HdsIconlibraryPoi_24px.LiquorOutline_24px]: '61885',
    [HdsIconlibraryPoi_24px.LiquorSolid_24px]: '61886',
    [HdsIconlibraryPoi_24px.LoadingDockOutline_24px]: '61887',
    [HdsIconlibraryPoi_24px.LoadingDockSolid_24px]: '61888',
    [HdsIconlibraryPoi_24px.MetroOutline_24px]: '61889',
    [HdsIconlibraryPoi_24px.MetroSolid_24px]: '61890',
    [HdsIconlibraryPoi_24px.MonorailOutline_24px]: '61891',
    [HdsIconlibraryPoi_24px.MonorailSolid_24px]: '61892',
    [HdsIconlibraryPoi_24px.MosqueOutline_24px]: '61893',
    [HdsIconlibraryPoi_24px.MosqueSolid_24px]: '61894',
    [HdsIconlibraryPoi_24px.MountainOutline_24px]: '61895',
    [HdsIconlibraryPoi_24px.MountainSolid_24px]: '61896',
    [HdsIconlibraryPoi_24px.MountainPassOutline_24px]: '61897',
    [HdsIconlibraryPoi_24px.MountainPassSolid_24px]: '61898',
    [HdsIconlibraryPoi_24px.MuseumOutline_24px]: '61899',
    [HdsIconlibraryPoi_24px.MuseumSolid_24px]: '61900',
    [HdsIconlibraryPoi_24px.MuseumArtOutline_24px]: '61901',
    [HdsIconlibraryPoi_24px.MuseumArtSolid_24px]: '61902',
    [HdsIconlibraryPoi_24px.NatureOutline_24px]: '61903',
    [HdsIconlibraryPoi_24px.NatureSolid_24px]: '61904',
    [HdsIconlibraryPoi_24px.NatureOverlookOutline_24px]: '61905',
    [HdsIconlibraryPoi_24px.NatureOverlookSolid_24px]: '61906',
    [HdsIconlibraryPoi_24px.NightClubOutline_24px]: '61907',
    [HdsIconlibraryPoi_24px.NightClubSolid_24px]: '61908',
    [HdsIconlibraryPoi_24px.PagodaOutline_24px]: '61909',
    [HdsIconlibraryPoi_24px.PagodaSolid_24px]: '61910',
    [HdsIconlibraryPoi_24px.ParkAndRideOutline_24px]: '61911',
    [HdsIconlibraryPoi_24px.ParkAndRideSolid_24px]: '61912',
    [HdsIconlibraryPoi_24px.ParkingOutline_24px]: '61913',
    [HdsIconlibraryPoi_24px.ParkingSolid_24px]: '61914',
    [HdsIconlibraryPoi_24px.ParkingBicycleOutline_24px]: '61915',
    [HdsIconlibraryPoi_24px.ParkingBicycleSolid_24px]: '61916',
    [HdsIconlibraryPoi_24px.ParkingGarageOutline_24px]: '61917',
    [HdsIconlibraryPoi_24px.ParkingGarageSolid_24px]: '61918',
    [HdsIconlibraryPoi_24px.ParkingMotorcycleOutline_24px]: '61919',
    [HdsIconlibraryPoi_24px.ParkingMotorcycleSolid_24px]: '61920',
    [HdsIconlibraryPoi_24px.PetrolStationOutline_24px]: '61921',
    [HdsIconlibraryPoi_24px.PetrolStationSolid_24px]: '61922',
    [HdsIconlibraryPoi_24px.PharmacyCrescentOutline_24px]: '61923',
    [HdsIconlibraryPoi_24px.PharmacyCrescentSolid_24px]: '61924',
    [HdsIconlibraryPoi_24px.PharmacyCrossOutline_24px]: '61925',
    [HdsIconlibraryPoi_24px.PharmacyCrossSolid_24px]: '61926',
    [HdsIconlibraryPoi_24px.PicnicAreaOutline_24px]: '61927',
    [HdsIconlibraryPoi_24px.PicnicAreaSolid_24px]: '61928',
    [HdsIconlibraryPoi_24px.PlaygroundOutline_24px]: '61929',
    [HdsIconlibraryPoi_24px.PlaygroundSolid_24px]: '61930',
    [HdsIconlibraryPoi_24px.PointOutline_24px]: '61931',
    [HdsIconlibraryPoi_24px.PointSolid_24px]: '61932',
    [HdsIconlibraryPoi_24px.PoliceOutline_24px]: '61933',
    [HdsIconlibraryPoi_24px.PoliceSolid_24px]: '61934',
    [HdsIconlibraryPoi_24px.PoolOutline_24px]: '61935',
    [HdsIconlibraryPoi_24px.PoolSolid_24px]: '61936',
    [HdsIconlibraryPoi_24px.PostOutline_24px]: '61937',
    [HdsIconlibraryPoi_24px.PostSolid_24px]: '61938',
    [HdsIconlibraryPoi_24px.PubOutline_24px]: '61939',
    [HdsIconlibraryPoi_24px.PubSolid_24px]: '61940',
    [HdsIconlibraryPoi_24px.PublicToiletOutline_24px]: '61941',
    [HdsIconlibraryPoi_24px.PublicToiletSolid_24px]: '61942',
    [HdsIconlibraryPoi_24px.PublicTransportOutline_24px]: '61943',
    [HdsIconlibraryPoi_24px.PublicTransportSolid_24px]: '61944',
    [HdsIconlibraryPoi_24px.RailLightOutline_24px]: '61945',
    [HdsIconlibraryPoi_24px.RailLightSolid_24px]: '61946',
    [HdsIconlibraryPoi_24px.RailRegionalOutline_24px]: '61947',
    [HdsIconlibraryPoi_24px.RailRegionalSolid_24px]: '61948',
    [HdsIconlibraryPoi_24px.RailYardOutline_24px]: '61949',
    [HdsIconlibraryPoi_24px.RailYardSolid_24px]: '61950',
    [HdsIconlibraryPoi_24px.RampOutline_24px]: '61951',
    [HdsIconlibraryPoi_24px.RampSolid_24px]: '61952',
    [HdsIconlibraryPoi_24px.ReligiousPlaceOutline_24px]: '61953',
    [HdsIconlibraryPoi_24px.ReligiousPlaceSolid_24px]: '61954',
    [HdsIconlibraryPoi_24px.ReligiousShintoJpnOutline_24px]: '61955',
    [HdsIconlibraryPoi_24px.ReligiousShintoJpnSolid_24px]: '61956',
    [HdsIconlibraryPoi_24px.ReligiousTempleBuddhistJpnOutline_24px]: '61957',
    [HdsIconlibraryPoi_24px.ReligiousTempleBuddhistJpnSolid_24px]: '61958',
    [HdsIconlibraryPoi_24px.RestaurantOutline_24px]: '61959',
    [HdsIconlibraryPoi_24px.RestaurantSolid_24px]: '61960',
    [HdsIconlibraryPoi_24px.SeaportHarborOutline_24px]: '61961',
    [HdsIconlibraryPoi_24px.SeaportHarborSolid_24px]: '61962',
    [HdsIconlibraryPoi_24px.ShoesOutline_24px]: '61963',
    [HdsIconlibraryPoi_24px.ShoesSolid_24px]: '61964',
    [HdsIconlibraryPoi_24px.ShoppingOutline_24px]: '61965',
    [HdsIconlibraryPoi_24px.ShoppingSolid_24px]: '61966',
    [HdsIconlibraryPoi_24px.ShrineGenericOutline_24px]: '61967',
    [HdsIconlibraryPoi_24px.ShrineGenericSolid_24px]: '61968',
    [HdsIconlibraryPoi_24px.SkiRunOutline_24px]: '61969',
    [HdsIconlibraryPoi_24px.SkiRunSolid_24px]: '61970',
    [HdsIconlibraryPoi_24px.SkywalkOutline_24px]: '61971',
    [HdsIconlibraryPoi_24px.SkywalkSolid_24px]: '61972',
    [HdsIconlibraryPoi_24px.StadiumOutline_24px]: '61973',
    [HdsIconlibraryPoi_24px.StadiumSolid_24px]: '61974',
    [HdsIconlibraryPoi_24px.StairsOutline_24px]: '61975',
    [HdsIconlibraryPoi_24px.StairsSolid_24px]: '61976',
    [HdsIconlibraryPoi_24px.SweetsOutline_24px]: '61977',
    [HdsIconlibraryPoi_24px.SweetsSolid_24px]: '61978',
    [HdsIconlibraryPoi_24px.SwimmingOutline_24px]: '61979',
    [HdsIconlibraryPoi_24px.SwimmingSolid_24px]: '61980',
    [HdsIconlibraryPoi_24px.SynagogueOutline_24px]: '61981',
    [HdsIconlibraryPoi_24px.SynagogueSolid_24px]: '61982',
    [HdsIconlibraryPoi_24px.TaxiOutline_24px]: '61983',
    [HdsIconlibraryPoi_24px.TaxiSolid_24px]: '61984',
    [HdsIconlibraryPoi_24px.TheaterOutline_24px]: '61985',
    [HdsIconlibraryPoi_24px.TheaterSolid_24px]: '61986',
    [HdsIconlibraryPoi_24px.TollBoothOutline_24px]: '61987',
    [HdsIconlibraryPoi_24px.TollBoothSolid_24px]: '61988',
    [HdsIconlibraryPoi_24px.TouristInformationOutline_24px]: '61989',
    [HdsIconlibraryPoi_24px.TouristInformationSolid_24px]: '61990',
    [HdsIconlibraryPoi_24px.TrainOutline_24px]: '61991',
    [HdsIconlibraryPoi_24px.TrainSolid_24px]: '61992',
    [HdsIconlibraryPoi_24px.TransportShinkansenJpnOutline_24px]: '61993',
    [HdsIconlibraryPoi_24px.TransportShinkansenJpnSolid_24px]: '61994',
    [HdsIconlibraryPoi_24px.TravelAgentTicketingOutline_24px]: '61995',
    [HdsIconlibraryPoi_24px.TravelAgentTicketingSolid_24px]: '61996',
    [HdsIconlibraryPoi_24px.TruckDealershipOutline_24px]: '61997',
    [HdsIconlibraryPoi_24px.TruckDealershipSolid_24px]: '61998',
    [HdsIconlibraryPoi_24px.TruckParkingOutline_24px]: '61999',
    [HdsIconlibraryPoi_24px.TruckParkingSolid_24px]: '62000',
    [HdsIconlibraryPoi_24px.TruckRepairOutline_24px]: '62001',
    [HdsIconlibraryPoi_24px.TruckRepairSolid_24px]: '62002',
    [HdsIconlibraryPoi_24px.TruckStopPlazaOutline_24px]: '62003',
    [HdsIconlibraryPoi_24px.TruckStopPlazaSolid_24px]: '62004',
    [HdsIconlibraryPoi_24px.TruckWashOutline_24px]: '62005',
    [HdsIconlibraryPoi_24px.TruckWashSolid_24px]: '62006',
    [HdsIconlibraryPoi_24px.TunnelOutline_24px]: '62007',
    [HdsIconlibraryPoi_24px.TunnelSolid_24px]: '62008',
    [HdsIconlibraryPoi_24px.WaterfallOutline_24px]: '62009',
    [HdsIconlibraryPoi_24px.WaterfallSolid_24px]: '62010',
    [HdsIconlibraryPoi_24px.WeighStationOutline_24px]: '62011',
    [HdsIconlibraryPoi_24px.WeighStationSolid_24px]: '62012',
    [HdsIconlibraryPoi_24px.ZooOutline_24px]: '62013',
    [HdsIconlibraryPoi_24px.ZooSolid_24px]: '62014',
};
//# sourceMappingURL=hds-iconlibrary-poi-24px.js.map